// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Clock_buttonsContainer__kGbMw","clock":"Clock_clock__w4YxK","watch":"Clock_watch__hEKy8","more":"Clock_more__Nzeky"};